export default "__VITE_ASSET__C1$leq2u__"